// Emergency service image URLs (Cloudinary)
// Updated: 2024-01-XX - All emergency service images uploaded to Cloudinary
const EMERGENCY_SERVICE_IMAGES = {
  'Wheelchair Service': 'https://res.cloudinary.com/dmmetrvda/image/upload/v1766362049/weheal/services/emergency/wheelchair.jpg',
  'Oxygen Cylinder Service': 'https://res.cloudinary.com/dmmetrvda/image/upload/v1766362048/weheal/services/emergency/oxygen-cylinder.jpg',
  'Emergency Ambulance Service': 'https://res.cloudinary.com/dmmetrvda/image/upload/v1766362047/weheal/services/emergency/ambulance.png',
  'Emergency Nurse Service': 'https://res.cloudinary.com/dmmetrvda/image/upload/v1766362051/weheal/services/emergency/nurse.jpg'
};

// Helper function to get emergency service image URL
export const getEmergencyServiceImageUrl = (serviceName) => {
  if (!serviceName) return null;
  
  // Check if it's a known emergency service
  const normalizedName = serviceName.toLowerCase();
  
  // Check for ambulance service (highest priority to avoid conflicts)
  if (normalizedName.includes('ambulance')) {
    return EMERGENCY_SERVICE_IMAGES['Emergency Ambulance Service'];
  }
  
  // Check for nurse service
  if (normalizedName.includes('nurse') || normalizedName.includes('emergency nurse')) {
    return EMERGENCY_SERVICE_IMAGES['Emergency Nurse Service'];
  }
  
  // Check for wheelchair service
  if (normalizedName.includes('wheelchair') || normalizedName.includes('wheel chair')) {
    return EMERGENCY_SERVICE_IMAGES['Wheelchair Service'];
  }
  
  // Check for oxygen cylinder service
  if (normalizedName.includes('oxygen') || normalizedName.includes('cylinder') || normalizedName.includes('oxygen cylinder')) {
    return EMERGENCY_SERVICE_IMAGES['Oxygen Cylinder Service'];
  }
  
  return null;
};

// Utility function to get image URL (works for both local and production)
export const getImageUrl = (imagePath) => {
  if (!imagePath || imagePath === '') {
    return null; // Return null for empty paths so components can handle fallback
  }
  
  // If it's already a full URL (Cloudinary or other), use it
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }
  
  // Determine base URL based on environment
  const isProduction = window.location.hostname === 'weheal-frontend.onrender.com';
  const baseUrl = isProduction 
    ? 'https://weheal-backend.onrender.com' 
    : 'http://localhost:5001';
  
  // If it starts with /uploads, it's a relative path from backend
  if (imagePath.startsWith('/uploads/')) {
    return `${baseUrl}${imagePath}`;
  }
  
  // If it doesn't start with /, check if it's a profile picture or product image
  if (!imagePath.startsWith('/')) {
    // Check if it looks like a profile picture path or filename
    if (imagePath.includes('profile') || imagePath.includes('profiles') || imagePath.match(/^profile-/)) {
      return `${baseUrl}/uploads/profiles/${imagePath}`;
    }
    // Default to products for backward compatibility
    return `${baseUrl}/uploads/products/${imagePath}`;
  }
  
  // Default: prepend backend URL
  return `${baseUrl}${imagePath}`;
};

